import { render, staticRenderFns } from "./CalloutBox.vue?vue&type=template&id=7d79a4ae"
import script from "./CalloutBox.vue?vue&type=script&lang=ts"
export * from "./CalloutBox.vue?vue&type=script&lang=ts"
import style0 from "./CalloutBox.vue?vue&type=style&index=0&id=7d79a4ae&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports